import React, { Component } from 'react';
import {CardDeck} from 'reactstrap';
import Slider from 'react-slick';
import { Container, Row, Col} from 'reactstrap';
import { bootstrapBreakpoints } from '../../utils/BootstrapBreakpoints'
import BrowserFeatures from '../../utils/BrowserFeatures'
import PubSub from 'pubsub-js';
import Constants from '../../Constants';
import Dom from '../../utils/Dom'
import EirButton from '../eir-button/EirButton';
import CartSummary from '../cart-summary/CartSummary';

function ArrowRight(props) {
  const {onClick} = props;
  return (
    <EirButton
      text=''
      type='link'
      icon='arrowright-white'
      className='arrowRight'
      onClick={onClick}
    />
  );
}

function ArrowLeft(props) {
  const {onClick} = props;
  return (
    <EirButton
      text=''
      type='link'
      icon='arrowleft-white'
      className='arrowLeft'
      onClick={onClick}
    />
  );
}

class ResponsiveEirMobileCardContainer extends Component {

  constructor(props) {
    super(props);
    Dom.addStyleSheet(Constants.externalCss.slickCarousel.minified);
    Dom.addStyleSheet(Constants.externalCss.slickCarousel.themeMinified);

    this.state = {
      breakpoint: bootstrapBreakpoints.getActiveBreakpoints(),
      settings: {
        infinite: false,
        dots: true,
        speed: 500,
        focusOnSelect: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        centerMode: true,
        respondTo: 'window',
        className: 'mx-auto',
        variableWidth: true,
        centerPadding: '0',
        initialSlide: props.initialSlide
      }
    };
  }

  componentWillUnmount() {
    if (this.state.bootstrapBreakpointChangedSubscription) {
      PubSub.unsubscribe(this.bootstrapBreakpointChangedSubscription);
    }
  }

  componentDidMount() {
    this.setState({
      bootstrapBreakpointChangedSubscription: PubSub.subscribe(Constants.eventKeys.bootstrapBreakpointChanged, (message, data) => this.handleBreakpointChanged(data))
    });
    this.toggleArrows();
  }

  toggleArrows() {
    if(BrowserFeatures.hasTouch()){
      this.setState({ settings: {...this.state.settings, ...{'arrows': false}} });
     }
     else {
      const settings = {'nextArrow': <ArrowRight/> ,'prevArrow': <ArrowLeft/>};
      this.setState({ settings: {...this.state.settings, ...settings} });
    }
  }

  handleBreakpointChanged = (breakpoint) => {
    this.setState({
      breakpoint: breakpoint
    });
  };

  render() {
    let size=12;
    let offset=0;
    let carousel = true;
    if (this.props.count == 4 && this.state.breakpoint.xl) {
      carousel = false;
    }

    if (this.props.count == 3 && this.state.breakpoint.lg) {
      carousel = false;
    }

    if (this.props.count === 2 && this.state.breakpoint.md) {
      carousel = false;
    }

    if (this.props.count === 1) {
      carousel = false;
    }
    
    if (!carousel) {
      if (this.props.count === 2) {
        if (this.state.breakpoint.lg) {
          size = 8;
          offset = 2;
        } else {
          size = 10;
          offset = 1;
        }
      }

      if (this.props.count === 1) {
        if(this.state.breakpoint.lg)
        {
          size = 4;
          offset = 4;
        }
        else if(this.state.breakpoint.md)
        {
          size = 6;
          offset = 3;
        }
        else if(this.state.breakpoint.sm)
        {
          size = 8;
          offset = 2;
        }
      }
    }

    if(!carousel){
      return (
        <Container className="mt-4 eir-card-container container-width">
          <Row>
            <CartSummary {...this.props.cartSummary} className="w-100 text-center mb-2 mt-2" />
          </Row>
          <Row>
            <Col xs={{ size, offset }}>
              <CardDeck className="d-flex">
                {this.props.children}
              </CardDeck>
            </Col>
          </Row>
        </Container>
      );
    }
    else
    {
      return (
          <div className={(this.props.prequalOnly ? 'eir-card-container-prequal' : 'eir-card-container') + ' eir-mobile-card-container'}>
          <CartSummary {...this.props.cartSummary} className="container w-100 text-center mb-2 mt-4" />
            <Slider {...this.state.settings}>
              {this.props.children}
            </Slider>
          </div>
        );
    }
  }
}
export default ResponsiveEirMobileCardContainer;